<template>
  <div class="teachingActivity">
    <div class="header">
      <div class="vote_status">投票状态: <span :class="['button',{'active_button':activeButton==1}]" @click="getAllStudent()">全部</span> <span :class="['button',{'active_button':activeButton==2}]" @click="getNoSignStudent()">只看未提交学生</span></div>
      <!-- <div class="left">签到状态: <el-button @click="getAllStudent()">全部</el-button><el-button @click="getNoSignStudent()">只看未提交学生</el-button></div> -->
      <div class="right"><el-button type="text" @click="getSignInDetial">刷新</el-button> <span>{{ signed_count }}人提交</span></div>
    </div>
    <el-table :data="selectStudentSignList" style="width: 100%" :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#f5f7fa',}" class="table-content" :cell-style="{fontSize: '12px',color: '#333'}">
      <el-table-column prop="s_name" label="学生名称">
      </el-table-column>
      <el-table-column prop="is_signed" label="提交状态">
        <template slot-scope="scope">
          <span :style="{color:scope.row.is_signed?'#333':'red'}"> {{ scope.row.is_signed?'已提交':'未提交' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sign_time" label="签到时间">
        <template slot-scope="scope">
          {{  scope.row.sign_time?scope.row.sign_time:'-'}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background @current-change="handleCurrentChangeData" :current-page.sync="pageParams.page" :page-size="pageParams.size" layout="prev, pager, next" :total="selectStudentSignList.length">
      </el-pagination>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "teacherTextbook",
  components: {},
  data() {
    return {
      activeButton: 1,
      query: {},
      studentSignList: [],
      total: 0,
      signed_count: 0,
      selectStudentSignList: [],
      pageParams: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this.query = JSON.parse(localStorage.getItem("query"));
    this.getSignInDetial();
  },

  methods: {
    getSignInDetial() {
      // 获取签到详情
      this.$shttp.axiosPost(
        this.$api.jdTActivitiesCheckinInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.studentSignList = res.data.student_status;
            this.selectStudentSignList = res.data.student_status;
            this.total = res.data.total;
            this.signed_count = res.data.signed_count;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getAllStudent() {
      this.activeButton = 1;
      this.selectStudentSignList = this.studentSignList;
    },
    getNoSignStudent() {
      this.activeButton = 2;
      this.selectStudentSignList = [];
      this.selectStudentSignList = this.studentSignList.filter(
        (item) => !item.is_signed
      );
    },
    handleCurrentChangeData() {},
  },
};
</script>
  
  <style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  background: #fff;
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .vote_status {
      height: 50px;
      display: flex;
      align-items: center;
      .button {
        display: inline-block;
        padding: 5px 10px;
        margin: 0 10px;
        background: #f9f9f9;
        border-radius: 4px 4px 4px 4px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
      .active_button {
        background: rgba(0, 110, 255, 0.1);
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        color: #006eff;
      }
    }
  }
  .table-content {
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdcdc;
  }
  .pagination {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>